import axios from "axios";

// Defined locally to avoid circular dependency with constants.js
const LIVE_TABLE_URL =
  process.env.REACT_APP_LIVE_TABLE_URL || "http://localhost:9010/api";

const liveTableApi = axios.create({
  baseURL: LIVE_TABLE_URL,
  timeout: 10000,
});

// Attach auth headers so /casino-odds/* calls don't 401
liveTableApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  let operatorId;
  try {
    operatorId = JSON.parse(localStorage.getItem("operatorId"));
  } catch {
    operatorId = localStorage.getItem("operatorId");
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (operatorId) config.headers["OperatorId"] = operatorId;
  return config;
});

/**
 * GET /api/game-list
 * Returns all available games with gmid, gname, active flag.
 */
export const getGameList = () => liveTableApi.get("/game-list");

/**
 * GET /api/games
 * Returns only games that are currently streaming.
 */
export const getActiveGames = () => liveTableApi.get("/games");

/**
 * GET /api/odds/{gmid}
 * Returns latest odds snapshot for a game.
 */
export const getLatestOdds = (gmid) => liveTableApi.get(`/odds/${gmid}`);

/**
 * GET /api/history/{gmid}?limit=N
 * Returns recent message history for a game.
 */
export const getMessageHistory = (gmid, limit = 10) =>
  liveTableApi.get(`/history/${gmid}`, { params: { limit } });

/**
 * GET /api/market/{gmid}/{mid}
 * Returns all messages for a specific round.
 */
export const getMarketData = (gmid, mid) =>
  liveTableApi.get(`/market/${gmid}/${mid}`);

/**
 * GET /api/connection-status
 * Returns { gmid: boolean } map of WebSocket connection status.
 */
export const getConnectionStatus = () =>
  liveTableApi.get("/connection-status");

/**
 * GET /api/casino-odds
 * Returns latest odds for ALL active games.
 * Response shape: { statusCode, message, data: { TEEN_20: {...}, DRAGON_TIGER_20: {...} } }
 */
export const getCasinoOdds = () => liveTableApi.get("/casino-odds");

/**
 * GET /api/casino-odds/{gameCode}
 * Returns latest odds for a specific game.
 * Response shape: { statusCode, message, data: { data: { casinoGames, autoTime, marketId, cards, oddDetailsDTOS } } }
 */
export const getCasinoOddsByGame = (gameCode) =>
  liveTableApi.get(`/casino-odds/${gameCode}`);

/**
 * GET /api/casino/game-catalog
 * Returns game catalog with gameKey, gameCode, name, category, bet limits.
 */
export const getGameCatalog = () => liveTableApi.get("/casino/game-catalog");

/**
 * GET /api/health
 * Returns { status: "UP", service: "live-table-games" }.
 */
export const healthCheck = () => liveTableApi.get("/health");
